import RadioButton from "../../../../../components/radioButton/RadioButton";
import Input from "../../../../../components/inputText/Input";
import Select from "../../../../../components/Select/Select";
import TextArea from "../../../../../components/TextArea/TextArea";
import React, {useEffect, useState} from "react";
import MediaQueryUtils from "../../../../../utils/MediaQueryUtils";
import Utils from "../../../../../utils/Utils";
import {removeSingleFile, setStateAssistente, setUpload} from "../../../../../actions/IndexActions";
import {useDispatch, useSelector} from "react-redux";
import oggettiUtili from "../../../../../utils/OggettiUtili.json";
import styleButton from "../../../../../components/Button/Button.module.css";
import styleDatiPersonali from "./DatiPersonali.module.css"
import Spinner from "../../../../../components/spinner/Spinner";

function InformazioniGenerali(props) {

    const [state, setState] = useState({})
    const [numAttestati, setNumAttestati] = useState(0)
    const [arrayAttestati, setArrayAttestati] = useState([])
    const [arraySelectLinguaParlata, setArraySelectLinguaParlata] = useState([])
    const selectOptions = oggettiUtili.linguaParlata
    let isPageWide = MediaQueryUtils('(min-width: 1150px)')
    const dispatch = useDispatch();
    const getAssistente = useSelector(state => state.wizardReducer)
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    const fileReducer = useSelector(state => state.fileReducer)
    const [showSpinner, setShowSpinner] = useState(false)
    const [maxSizeAttestato, setMaxSizeAttestato] = useState(false)


    useEffect(() => {
        if (getAssistente && getAssistente.infoGenerali) {
            let newState = getAssistente.infoGenerali
            setState(newState)
        }
    }, [])

    useEffect(() => {
        validateCampiCondizionati()
        createArraySelectLinguaParlata()
        dispatch(setStateAssistente("infoGenerali", state))
    }, [state && state.linguaParlata && state.linguaParlata.length, state, setState])

    useEffect( () => {
        showAttestati()
    }, [numAttestati, setNumAttestati])

    function validateCampiCondizionati() {
        if (Object.keys(state).length !== 0) {
            if (!(state.patente && state.patente === "1") && state.tipologiaPatente) delete state.tipologiaPatente
            if (!(state.italianoMadreLingua && state.italianoMadreLingua === "2") && state.linguaItalianaParlataCompresa) delete state.linguaItalianaParlataCompresa
            if (!(state.italianoMadreLingua && state.italianoMadreLingua === "2") && state.linguaParlata && state.linguaParlata.length !== 0) delete state.linguaParlata
            if (!(state.corso && state.corso === "1") && state.tipologiaEnteCorso) delete state.tipologiaEnteCorso
            if (!(state.corsoVicinato && state.corsoVicinato === "1") && state.tipologiaEnteCorsoVicinato) delete state.tipologiaEnteCorsoVicinato
        }
    }

    function addLinguaParlata() {
        let newState = {...state}
        newState.linguaParlata.push("")
        setState(newState)
    }

    function removeLinguaParlata(index) {
        let newState = {...state}
        newState.linguaParlata.splice(index, 1)
        setState(newState)
    }

    function createArraySelectLinguaParlata() {
        let newArraySelect = []
        let newState = {...state}
        if (!(newState && newState.linguaParlata)) newState.linguaParlata = [""]
        newState.linguaParlata.forEach(function (linguaParlata, idx) {
                let newSelect = (
                        idx > 0 ?
                            <div className={"row"} style={{marginTop: "5px"}}>
                                <div className={"col-9"}>
                                    <Select
                                        value={linguaParlata}
                                        ariaLabel={"Lingua parlata ".concat(idx + 1)}
                                        onChange={(event) => setState(Utils.riceviValoreMultiValue(state, event.target.id, event.target.value, idx))}
                                        options={selectOptions}
                                        id={"linguaParlata" + idx}
                                        style={{width: "94%"}}
                                    />
                                </div>
                                {/* Era un <div onClick>: non focusabile ne' attivabile da
                                    tastiera (WCAG 2.1.1), per di piu' su un'azione
                                    distruttiva. Il <div> resta come cella di layout e
                                    l'azione passa a un <button> con reset di stile, cosi'
                                    la resa grafica e' invariata. */}
                                <div className={"col-2"} style={{marginTop: "10px"}}>
                                    <button type="button"
                                            onClick={() => removeLinguaParlata(idx)}
                                            aria-label={"Elimina lingua parlata ".concat(idx + 1)}
                                            style={{background: "none", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer", lineHeight: 0}}>
                                        <svg aria-hidden="true" focusable="false"
                                             xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red"
                                             className="bi bi-trash" viewBox="0 0 16 16">
                                            <path
                                                d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                            <path fillRule="evenodd"
                                                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            :
                            <div>
                                <Select
                                    value={linguaParlata}
                                    ariaLabel={"Lingua parlata ".concat(idx + 1)}
                                    onChange={(event) => setState(Utils.riceviValoreMultiValue(state, event.target.id, event.target.value, idx))}
                                    options={selectOptions}
                                    id={"linguaParlata" + idx}
                                    style={{width: "70%"}}
                                />
                            </div>
                )
                newArraySelect.push(newSelect)
            }
        )
        return setArraySelectLinguaParlata(newArraySelect)
    }

    function uploadFileAttestati(event) {
        setShowSpinner(true)
        if(event.target.files[0].size > 1000000){
            setMaxSizeAttestato(true)
            setShowSpinner(false)
        }
        else{
            setMaxSizeAttestato(false)
            Utils.toBase64(event.target.files[0]).then(res => {
                if(res){
                    let newStateUpload = {...fileReducer}
                    if(!(newStateUpload && newStateUpload.attestati)){
                        newStateUpload.attestati = []
                    }
                    let attestato = {
                        nomeFile : event.target.files[0].name,
                        fileBase64: res
                    }
                    newStateUpload.attestati.push(attestato)
                    dispatch(setUpload("attestati", newStateUpload.attestati))
                    setNumAttestati(numAttestati+1)
                }
                setShowSpinner(false)
            }).catch(reason => {
                setShowSpinner(false)
                console.log("Errore Operation Caricamento File: "+reason)
            })
        }


    }

    function showAttestati(){

        let showAttestati = []

        if(fileReducer && fileReducer.attestati && fileReducer.attestati.length > 0){
            fileReducer.attestati.forEach(attestato => {
                let showAttestato = (
                    <div className={"row"}>
                        <br/>
                        <div className={"col-4"}>
                            <span>{attestato.nomeFile}</span>
                        </div>
                        <div className={"col-1"} >
                            {/* Gli SVG di scarica/elimina erano <svg onClick>: non
                                raggiungibili ne' attivabili da tastiera (WCAG 2.1.1).
                                Ora sono avvolti in <button type="button"> con reset di
                                stile, quindi la resa grafica resta identica; il nome
                                accessibile lo da' l'aria-label del button e gli SVG sono
                                aria-hidden. */}
                            <button type="button"
                                    onClick={() => downloadFile(fileReducer.attestati.indexOf(attestato))}
                                    aria-label={"Scarica attestato di formazione: ".concat(attestato.nomeFile)}
                                    style={{background: "none", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer", lineHeight: 0, verticalAlign: "middle"}}>
                                <svg
                                    aria-hidden="true" focusable="false"
                                    xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#1b7ea9"
                                     className="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
                                    <path
                                        d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z"/>
                                    <path
                                        d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                                </svg>
                            </button>

                            <button type="button"
                                    onClick={() => removeAttestato(fileReducer.attestati.indexOf(attestato))}
                                    aria-label={"Elimina attestato di formazione: ".concat(attestato.nomeFile)}
                                    style={{background: "none", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer", marginLeft: "15px", lineHeight: 0, verticalAlign: "middle"}}>
                                <svg aria-hidden="true" focusable="false"
                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red"
                                     className="bi bi-trash" viewBox="0 0 16 16">
                                    <path
                                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                    <path fillRule="evenodd"
                                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                )
                showAttestati.push(showAttestato)
            })
        }

        return setArrayAttestati(showAttestati)
    }

    function downloadFile(index){

        (function() {
            setMaxSizeAttestato(false)
            // convert base64 string to byte array
            var byteCharacters = atob(fileReducer.attestati[index].fileBase64);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);

            // now that we have the byte array, construct the blob from it
            var blob1 = new Blob([byteArray], {type: "application/octet-stream"});

            var fileName1 = fileReducer.attestati[index].nomeFile;
            Utils.saveAs(blob1, fileName1);
        })();
    }

    function removeAttestato(index){
        setMaxSizeAttestato(false)
        dispatch(removeSingleFile("attestati", index))
        setNumAttestati(numAttestati + 1)
    }

    return (
        <div>
            <Spinner show={showSpinner}/>
            <div className={"row"}>
                <div className={isPageWide ? "col-2" : "col-4"} style={{marginTop: ".6rem"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Patente di guida:</span>
                    <span className={"obbligatorietaColor"}>*</span>
                </div>
                <div className={isPageWide ? "col-8" : "col-3"}>
                    <div className={"row"}>
                        <RadioButton
                            id={"patenteSi"}
                            text={"Si"}
                            onChange={(event) => setState(Utils.riceviValore(state, "patente", event.target.value))}
                            value={"1"}
                            checked={state && state.patente && state.patente === "1"}
                        />
                        <RadioButton
                            id={"patenteNo"}
                            text={"No"}
                            value={"2"}
                            onChange={(event) => setState(Utils.riceviValore(state, "patente", event.target.value))}
                            checked={state && state.patente && state.patente === "2"}
                        />
                    </div>
                </div>
                <div className={isPageWide ? "col-2" : "col-5"} style={{marginTop: ".6rem"}}>
                    <span style={{color: "red", fontWeight: "bold"}}>*Campo Obbligatorio</span>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-4" : "col-10"} style={{marginTop: "10px"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Tipologia di patente:</span>
                    {(state.patente && state.patente === "1") && <span className={"obbligatorietaColor"}>*</span> }
                    <br/>
                    <Select
                            value={state && state.tipologiaPatente ? state.tipologiaPatente : ""}
                            onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}
                            ariaLabel={"Tipologia di patente"}
                            options={oggettiUtili.tipologiaPatente}
                            id={"tipologiaPatente"}
                            style={{width: "70%"}}
                        />
                </div>
            </div>
            <div className={"row"} style={{marginTop: "10px"}}>
                <div className={isPageWide ? "col-2" : "col-4"} style={{marginTop: ".6rem"}}>
                    <span style={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        color: "#505050",
                        marginTop: ".8rem"
                    }}>Automunito/a:</span>
                </div>
                <div className={isPageWide ? "col-4" : "col-3"}>
                    <div className={"row"}>
                        <RadioButton
                            id={"automunitoSi"}
                            text={"Si"}
                            onChange={(event) => setState(Utils.riceviValore(state, "automunito", event.target.value))}
                            value={"1"}
                            checked={state && state.automunito && state.automunito === "1"}
                        />
                        <RadioButton
                            id={"automunitoNo"}
                            text={"No"}
                            value={"2"}
                            onChange={(event) => setState(Utils.riceviValore(state, "automunito", event.target.value))}
                            checked={state && state.automunito && state.automunito === "2"}
                        />
                    </div>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-4" : "col-10"} style={{marginTop: "10px"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Altro mezzo di trasporto utilizzato (specificare):</span>
                    <br/>
                    <Input id={"altroMezzoTrasporto"} style={{width: "70%"}}
                                 ariaLabel={"Altro mezzo di trasporto utilizzato (specificare)"}
                                 value={state && state.altroMezzoTrasporto ? state.altroMezzoTrasporto : ""}
                                 onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}
                                 placeholder={"Mezzo"}/>
                </div>
            </div>
            <div className={"row"} style={{marginTop: "10px"}}>
                <div className={isPageWide ? "col-2" : "col-4"} style={{marginTop: ".6rem"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050", marginTop: ".8rem"}}>Italiano madrelingua:</span>
                    <span className={"obbligatorietaColor"}>*</span>
                </div>
                <div className={"col-4"}>
                    <div className={"row"}>
                        <RadioButton
                            id={"italianoMadreLinguaSi"}
                            text={"Si"}
                            onChange={(event) => setState(Utils.riceviValore(state, "italianoMadreLingua", event.target.value))}
                            value={"1"}
                            checked={state && state.italianoMadreLingua && state.italianoMadreLingua === "1"}
                        />
                        <RadioButton
                            id={"italianoMadreLinguaNo"}
                            text={"No"}
                            value={"2"}
                            onChange={(event) => setState(Utils.riceviValore(state, "italianoMadreLingua", event.target.value))}
                            checked={state && state.italianoMadreLingua && state.italianoMadreLingua === "2"}
                        />
                    </div>
                </div>
            </div>
            <fieldset disabled={!(state && state.italianoMadreLingua && state.italianoMadreLingua === "2")}>
                <div className={"row"}>
                    <div className={isPageWide ? "col-4" : "col-10"} style={{marginTop: "10px"}}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Lingua italiana parlata e compresa:</span>
                        {(state && state.italianoMadreLingua && state.italianoMadreLingua === "2") ?
                            <span className={"obbligatorietaColor"}>*</span> : <></>}
                        <br/>
                        <Select
                                value={state && state.linguaItalianaParlataCompresa ? state.linguaItalianaParlataCompresa : ""}
                                onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}
                                ariaLabel={"Lingua italiana parlata e compresa"}
                                options={oggettiUtili.linguaItalianaCompresa}
                                id={"linguaItalianaParlataCompresa"}
                                style={{width: "70%"}}
                            />
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className={isPageWide ? "col-4" : "col-10"}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Lingua parlata:</span>
                        {(state && state.italianoMadreLingua && state.italianoMadreLingua === "2") ?
                            <span className={"obbligatorietaColor"}>*</span> : <></>}
                        <br/>
                        {arraySelectLinguaParlata}
                    </div>
                    <div className={isPageWide ? "col-7" : "col-12"}>
                        {/* Era un <div onClick>: non focusabile ne' attivabile da tastiera
                            (WCAG 2.1.1). Convertito in <button type="button"> con reset di
                            stile e display:flex per riprodurre la .row precedente, quindi
                            la resa grafica e' invariata. La condizione che prima veniva
                            valutata dentro l'handler diventa l'attributo disabled, cosi'
                            lo stato non attivo e' esposto anche alle tecnologie assistive
                            (prima l'opacita' 0.5 era l'unico indizio, solo visivo). */}
                        <button type="button"
                                className={"row"}
                                onClick={addLinguaParlata}
                                disabled={!(sessioneUtente && sessioneUtente.tipoUtente !== "03" && state && state.linguaParlata && (state.linguaParlata[0] !== "" || state.linguaParlata.length > 1))}
                                style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    font: "inherit",
                                    color: "inherit",
                                    textAlign: "left",
                                    width: "100%",
                                    display: "flex",
                                    marginTop: isPageWide ? "2rem" : "1rem",
                                    cursor: sessioneUtente && sessioneUtente.tipoUtente !== "03"?"pointer":"",
                                    opacity: !(state && state.linguaParlata) || state && state.linguaParlata && state.linguaParlata[0] === "" && state.linguaParlata.length < 2 ? "0.5" : "1"
                                }}>
                            <div className={"col-1"} style={{flex: "0 0 2%"}}>
                                <svg aria-hidden="true" focusable="false"
                                     xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="#1b7ea9"
                                     className="bi bi-plus-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path
                                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                </svg>
                            </div>
                            <div className={"col-6"} style={{marginTop: "4px"}}>
                                <span style={{fontSize: "18px", color: "#1b7ea9"}}>Inserisci nuova lingua parlata</span>
                            </div>
                        </button>
                    </div>
                </div>
            </fieldset>
            <div className={"row"}>
                <div className={isPageWide ? "col-4" : "col-10"} style={{marginTop: "10px"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Titolo di studio:</span>
                    <br/>
                   <Select
                            value={state && state.titoloDiStudio ? state.titoloDiStudio : ""}
                            onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}
                            ariaLabel={"Titolo di studio"}
                            options={oggettiUtili.titoloDiStudio}
                            id={"titoloDiStudio"}
                            style={{width: "70%"}}
                        />
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-4" : "col-10"} style={{marginTop: "10px"}}>
                    <span
                        style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Paese di conseguimento:</span>
                    <br/>
                   <Input id={"paeseTitoloDiStudio"} style={{width: "70%"}}
                                 ariaLabel={"Paese di conseguimento"}
                                 value={state && state.paeseTitoloDiStudio ? state.paeseTitoloDiStudio : ""}
                                 onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}
                                 placeholder={"Paese"}/>
                </div>
            </div>
            <div className={"row"} style={{marginTop: "10px"}}>
                <div className={isPageWide ? "col-4" : "col-5"} style={{marginTop: ".6rem"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050", marginTop: ".8rem"}}>Corso di formazione come assistente familiare:</span>
                    <span className={"obbligatorietaColor"}>*</span>
                </div>
                <div className={isPageWide ? "col-4" : "col-3"}>
                    <div className={"row"}>
                        <RadioButton
                            id={"corsoSi"}
                            text={"Si"}
                            onChange={(event) => setState(Utils.riceviValore(state, "corso", event.target.value))}
                            value={"1"}
                            checked={state && state.corso && state.corso === "1"}
                        />
                        <RadioButton
                            id={"corsoNo"}
                            text={"No"}
                            value={"2"}
                            onChange={(event) => setState(Utils.riceviValore(state, "corso", event.target.value))}
                            checked={state && state.corso && state.corso === "2"}
                        />
                    </div>
                </div>
            </div>
            <fieldset disabled={!(state && state.corso && state.corso === "1")}>
                <div style={{marginTop: "10px"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Specificare la tipologia e presso quale Ente:</span>
                    {(state && state.corso && state.corso === "1") ?
                        <span className={"obbligatorietaColor"}>*</span> : <></>}
                    <br/>
                    <TextArea id={"tipologiaEnteCorso"} style={{width: isPageWide ? "33%" : "66%"}} rows={"5"}
                                    ariaLabel={"Corso di formazione come assistente familiare: specificare la tipologia e presso quale Ente (obbligatorio)"}
                                    value={state && state.tipologiaEnteCorso ? state.tipologiaEnteCorso : ""}
                                    onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}/>
                </div>
            </fieldset>

            <div className={"row"} style={{marginTop: "10px"}}>
                <div className={isPageWide ? "col-4" : "col-5"} style={{marginTop: ".6rem"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050", marginTop: ".8rem"}}>Corso di formazione come assistente familiare di vicinato:</span>
                    <span className={"obbligatorietaColor"}>*</span>
                </div>
                <div className={isPageWide ? "col-4" : "col-3"}>
                    <div className={"row"}>
                        <RadioButton
                            id={"corsoVicinatoSi"}
                            text={"Si"}
                            onChange={(event) => setState(Utils.riceviValore(state, "corsoVicinato", event.target.value))}
                            value={"1"}
                            checked={state && state.corsoVicinato && state.corsoVicinato === "1"}
                        />
                        <RadioButton
                            id={"corsoVicinatoNo"}
                            text={"No"}
                            value={"2"}
                            onChange={(event) => setState(Utils.riceviValore(state, "corsoVicinato", event.target.value))}
                            checked={state && state.corsoVicinato && state.corsoVicinato === "2"}
                        />
                    </div>
                </div>
            </div>
            <fieldset disabled={!(state && state.corsoVicinato && state.corsoVicinato === "1")}>
                <div style={{marginTop: "10px"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Specificare la tipologia e presso quale Ente:</span>
                    {(state && state.corsoVicinato && state.corsoVicinato === "1") ?
                        <span className={"obbligatorietaColor"}>*</span> : <></>}
                    <br/>
                    <TextArea id={"tipologiaEnteCorsoVicinato"} style={{width: isPageWide ? "33%" : "66%"}} rows={"5"}
                              ariaLabel={"Corso di formazione come assistente familiare di vicinato: specificare la tipologia e presso quale Ente (obbligatorio)"}
                              value={state && state.tipologiaEnteCorsoVicinato ? state.tipologiaEnteCorsoVicinato : ""}
                              onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}/>
                </div>
            </fieldset>
            <div style={{marginTop: "10px"}}>
                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Attestati di formazione:</span>
                {arrayAttestati}
                <br/>
                <label htmlFor={"attestatiDiFormazione"} style={{cursor:"pointer", width: "110px", height: "45px"}} className={" ".concat(styleDatiPersonali.buttonFile).concat(" ").concat(styleButton.btnBlu)}>
                    {/* L'input era display:none, quindi non focusabile: il caricamento
                        del file era impossibile da tastiera (WCAG 2.1.1). Ora e' solo
                        nascosto visivamente ma resta nel flusso di tabulazione; la label
                        lo referenzia con htmlFor. Resa grafica invariata. */}
                    <input id={"attestatiDiFormazione"}
                           type="file"
                           accept={".jpg, .jpeg, .gif, .png, .pdf"}
                           onChange={(event => uploadFileAttestati(event))}
                           style={{opacity: 0, position: "absolute", width: "0.1px", height: "0.1px", overflow: "hidden", zIndex: -1}}
                           multiple={false}
                    />
                    <p style={{margin:"auto"}}>Scegli file</p>
                </label>
                {maxSizeAttestato ?
                    <div>
                            <span className={"obbligatorietaColor"} style={{fontWeight: "bold", fontSize: "14px"}}>
                                Dimensione massima di 1Mb superata
                            </span>
                    </div>
                    : <></>}
            </div>
        </div>
    )
}

export default InformazioniGenerali
